import React, { useState, useEffect, useCallback } from 'react';
import { PAGESIZE } from '../constantes/constantes';
import { generateSessionId } from '../functions/functions';
import Paginacion from './paginacion/Paginacion';
import Loading from './loading/Loading';
import BusquedaForm from './busquedaForm/BusquedaForm';
import Resultados from './resultados/Resultados';
import { getSearch } from '../services/getSearch';
import { postToken } from '../services/postToken';
import PaginacionMobile from './paginacion/paginacionMobile';

export default function BuscadorApp() {
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('');
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [showLoading, setShowLoading] = useState(true);
  const [retry401Count, setRetry401Count] = useState(0);
  const [retry500Count, setRetry500Count] = useState(0);
  const [postTokenRetryCount, setPostTokenRetryCount] = useState(0);
  const [token, setToken] = useState(localStorage.getItem('sessionToken'));
  const [pathURL, setPathURL] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [isDomainAllowed, setIsDomainAllowed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 850);
  const [paramsReceivedFromWP, setParamsReceivedFromWP] = useState(false);

  const isMobileDevice = useCallback(() => {
    setIsMobile(window.innerWidth <= 850);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', isMobileDevice);
    return () => window.removeEventListener('resize', isMobileDevice);
  }, [isMobileDevice]);

  const handlePageChangeMobile = () => {
    setPage(prevPage => prevPage + 1);
    setSearchTrigger(prev => prev + 1);
    setRetry401Count(0);
    setRetry500Count(0);
  };

  // valida que el dominio pertenezca a clarosports/unotv
  useEffect(() => {
    const domain = window.location.hostname;
    const isAllowed =
      domain.includes('clarosports.com') ||
      domain.includes('amxinfra') ||
      domain.endsWith('clarosports.com') ||
      domain.includes('unotv.com') ||
      domain.endsWith('unotv.com') ||
      domain.includes('localhost');
    setIsDomainAllowed(isAllowed);
  }, []);

  // useEffect(() => {
  //   // Handle message from parent to get search parameters
  //   const handleMessage = (event) => {
  //     const origin = new URL(event.origin);
  //     if (
  //       origin.hostname.includes('localhost') ||
  //       origin.hostname.includes('amxinfra') ||
  //       origin.hostname.endsWith('clarosports.com') ||
  //       origin.hostname.includes('unotv.com') ||
  //       origin.hostname.endsWith('unotv.com')
  //     ) {
  //       setPathURL(event.origin);
  //       const urlParams = new URLSearchParams(event.data.params);
  //       console.log(" url params... ", urlParams)
  //       setQuery(urlParams.get('q') || '');
  //       setCategory(urlParams.get('category') || '');
  //       setPage(parseInt(urlParams.get('from'), 10) || 0);
  //       // setSearchTrigger(prev => prev + 1);
  //       setParamsReceivedFromWP(true);
  //       // console.log(" trigger...", urlParams.get('q'), " categoria: ", urlParams.get('category'), " pagina: ", urlParams.get('from'))
  //     }
  //   };

  //   window.addEventListener('message', handleMessage);
  //   // Cleanup event listener on component unmount
  //   return () => window.removeEventListener('message', handleMessage);
  // }, []);
  useEffect(() => {
  let initialized = false;

  const handleMessage = (event) => {
    if (initialized) return;
    initialized = true;

    const origin = new URL(event.origin);
    if (
      origin.hostname.includes('localhost') ||
      origin.hostname.includes('amxinfra') ||
      origin.hostname.endsWith('clarosports.com') ||
      origin.hostname.includes('unotv.com') ||
      origin.hostname.endsWith('unotv.com')
    ) {
      setPathURL(event.origin);
      const urlParams = new URLSearchParams(event.data.params);
      setQuery(urlParams.get('q') || '');
      setCategory(urlParams.get('category') || '');
      setPage(parseInt(urlParams.get('from'), 10) || 0);
      setSearchTrigger(prev => prev + 1);
      setParamsReceivedFromWP(true);
    }
  };

  window.addEventListener('message', handleMessage);
  return () => window.removeEventListener('message', handleMessage);
}, []);

  // useEffect(() => {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     const q = urlParams.get('q');
  //     const cat = urlParams.get('category');
  //     const from = urlParams.get('from');

  //   // Synchronize with URL parameters after receiving values from parent
  //   if (!query && page === 0 && !searchTrigger) {
  //     const urlParams = new URLSearchParams(window.location.search);
  //     setQuery(q || '');
  //     setCategory(cat || '');
  //     setPage(parseInt(from, 10) || 0);
  //     setSearchTrigger(prev => prev + 1);
  //   }
  // }, []);
  useEffect(() => {
    if (!paramsReceivedFromWP) {
      const urlParams = new URLSearchParams(window.location.search);
      const q = urlParams.get('q');
      const cat = urlParams.get('category');
      const from = parseInt(urlParams.get('from'), 10);

      setQuery(q || '');
      setCategory(cat || '');
      setPage(Number.isNaN(from) ? 0 : from);
      setSearchTrigger(prev => prev + 1);
    }
  }, [paramsReceivedFromWP]);

  const sessionId = useCallback(() => {
    let sessionId = localStorage.getItem('sessionId');
    if (!sessionId) {
      sessionId = generateSessionId();
      localStorage.setItem('sessionId', sessionId);
    }
    return sessionId;
  }, []);

  const getNewToken = useCallback(async () => {
    try {
      const id = sessionId();
      const response = await postToken({ user_id: id });

      if (response?.statusCode === 200) {
        const newToken = response.data.token;
        localStorage.setItem('sessionToken', newToken);
        setToken(newToken);
        return newToken;
      }
    } catch (error) {
      console.error("Error obteniendo nuevo token:", error);
    }
    return null;
  }, [sessionId]);

  const fetchSearch = useCallback(
    async (currentToken, isRetry401 = false, isRetry500 = false) => {
      if (retry401Count >= 1) {
        console.warn('Máximo intento por error 401 alcanzado.');
        setShowLoading(false);
        return;
      }

      if (retry500Count >= 2) {
        console.warn('Máximo intento por error 500 alcanzado.');
        setShowLoading(false);
        return;
      }

      setShowLoading(true);

      try {
        const result = await getSearch(query, page, PAGESIZE, category, currentToken);

        if (result.statusCode === 401) {
          if (!isRetry401) {
            setRetry401Count(prev => prev + 1);
            const newToken = await getNewToken();
            if (newToken) {
              await fetchSearch(newToken, true, isRetry500);
            }
          } else {
            console.warn('Segundo intento con nuevo token también falló (401).');
          }
          return;
        }

        if (result.statusCode === 500) {
          if (!isRetry500 || retry500Count < 2) {
            setRetry500Count(prev => prev + 1);
            console.warn(`Reintentando por error 500 (${retry500Count + 1}/3)...`);
            await fetchSearch(currentToken, isRetry401, true);
          } else {
            console.warn('Tercer intento por error 500 falló. Deteniendo.');
          }
          return;
        }
        
        // Éxito: limpiamos contadores
        setRetry401Count(0);
        setRetry500Count(0);

        if (isMobile) {
          setData(prevData => {
            const safePrevData = prevData || { hits: [] };
            const newHits = Array.isArray(result.data.hits) ? result.data.hits : [];
            const areHitsEqual =
              safePrevData.hits.length > 0 &&
              newHits.length > 0 &&
              safePrevData.hits[0].title === newHits[0].title;

            return {
              from: result.data.from,
              total: result.data.total,
              hits: areHitsEqual ? [...safePrevData.hits] : [...safePrevData.hits, ...newHits],
            };
          });
        } else {
          setData(result.data);
        }

      } catch (error) {
        console.error('Error durante fetchSearch:', error);
      } finally {
        setShowLoading(false);
      }
    },
    [query, page, category, isMobile, retry401Count, retry500Count, getNewToken]
  );

  // Send height for WP resize with useCallback to maintain reference
  const sendHeight = useCallback(() => {
    if (pathURL) {
      const container = document.querySelector('.container');
      if (container) {
        const height = Math.max(container.offsetHeight, 800); // Mínimo 800px
        const data = { type: 'resize', height };
        console.log('Enviando altura al iframe:', height);
        window.parent.postMessage(data, pathURL);
      }
    }
  }, [pathURL]);

  // Send search parameters for WP connection
  const sendParams = useCallback((params) => {
    if (!pathURL) return;
    console.log("envio de parametros: ", params)

    // Evita enviar valores vacíos que van a reemplazar la URL en WP
    if (!params.q && !params.from && params.from !== 0) {
      console.warn('Parámetros vacíos, no se envían');
      return;
    }

    const data = { type: 'params', params };
    window.parent.postMessage(data, pathURL);
  }, [pathURL]);

  useEffect(() => {
    if (!token && postTokenRetryCount < 2) {
      getNewToken().then(newToken => {
        if (newToken) {
          fetchSearch(newToken);
          setPostTokenRetryCount(0); // éxito, reinicia contador
        } else {
          setPostTokenRetryCount(prev => prev + 1); // error, suma intento
        }
      });
    }

    if (postTokenRetryCount >= 2) {
      console.warn("postToken falló múltiples veces. Deteniendo intentos.");
      setShowLoading(false);
    }
  }, [token, postTokenRetryCount, getNewToken, fetchSearch]);

  useEffect(() => {
    if (searchTrigger > 0 && token && paramsReceivedFromWP) {
      fetchSearch(token);
      // sendParams({ q: query, category: category, from: page });
      // Espera un momento para asegurar que los estados ya fueron seteados
      setTimeout(() => {
        sendParams({ q: query, category: category, from: page });
      }, 100);
      // Enviar altura después de un pequeño delay para que React renderice
      setTimeout(() => {
        sendHeight();
      }, 300);
    }
  }, [searchTrigger, token, fetchSearch, query, category, page, paramsReceivedFromWP, sendParams, sendHeight]);

  useEffect(() => {
    if ((query || category) && page === 0 && isMobile) {
      setData(null);
    }
  }, [isMobile, query, category, page]);

  const handleQueryChange = (query) => {
    setQuery(query);
    setPage(0);
    setRetry401Count(0);
    setRetry500Count(0);
  };

  // Reset to first page when changing category 
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
    setPage(0);
    setSearchTrigger(prev => prev + 1);
    setRetry401Count(0);
    setRetry500Count(0);
  };

  // Reset to first page when making a new search
  const handleSearch = () => {
    setPage(0);
    setSearchTrigger(prev => prev + 1);
    setRetry401Count(0);
    setRetry500Count(0);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setSearchTrigger(prev => prev + 1);
    setRetry401Count(0);
    setRetry500Count(0);
  };

  // Update height for resize - se ejecuta cuando cambia data, isMobile o pathURL
  useEffect(() => {
    // Enviar altura inmediatamente
    sendHeight();

    // También enviar cuando termina de cargar la página
    window.addEventListener('load', sendHeight);
    
    // Y cuando la ventana se redimensiona
    window.addEventListener('resize', sendHeight);

    return () => {
      window.removeEventListener('load', sendHeight);
      window.removeEventListener('resize', sendHeight);
    };
  }, [pathURL, sendHeight, data]);

  if (!isDomainAllowed) {
    return (
      <div id="modalForbbiden" className="forbbiden">
        <h1>Sitio no autorizado</h1>
      </div>
    );
  }

  return (
    <main className="grid-layout">
      <BusquedaForm
        query={query}
        setQuery={setQuery}
        category={category}
        onQueryChange={handleQueryChange}
        onCategoryChange={handleCategoryChange}
        onSearch={handleSearch}
        token={token}
        retryCount={retry401Count}
        setToken={setToken}
        setRetryCount={setRetry401Count}
        sessionId={sessionId}
        errorService={false}
        isMobile={isMobile}
        setData={setData}
      />

      {showLoading && <Loading />}

      {!showLoading && <Resultados data={data} query={query} />}
      
      {data && data.total > PAGESIZE && !showLoading && (
        <>
          {!isMobile ? (
            <Paginacion
              currentPage={page}
              total={data.total}
              pageSize={PAGESIZE}
              onPageChange={handlePageChange}
            />
          ) : (
            <PaginacionMobile
              currentPage={page}
              total={data.total}
              pageSize={15}
              onPageChange={handlePageChangeMobile}
            />
          )}
        </>
      )}
    </main>
  );
}